import { Company } from 'api';
import type { FirmCompany } from 'common/types/company';

export const isFirmWaterfallCompany = (company: Pick<FirmCompany, 'company_type'>): boolean =>
  // Holdings remain reachable through parent.child_companies; only typed Portfolio companies are direct inputs.
  company.company_type === Company.type.PORTFOLIO;

export const getFirmWaterfallCompanies = (
  companyList: FirmCompany[] | null | undefined
): FirmCompany[] | null | undefined => companyList?.filter(isFirmWaterfallCompany) ?? companyList;
